var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconSyncActive(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 2C4.8675 2 1.5 5.3675 1.5 9.5C1.5 13.6325 4.8675 17 9 17C13.1325 17 16.5 13.6325 16.5 9.5C16.5 5.3675 13.1325 2 9 2ZM12.585 7.775L8.3325 12.0275C8.2275 12.1325 8.085 12.1925 7.935 12.1925C7.785 12.1925 7.6425 12.1325 7.5375 12.0275L5.415 9.905C5.1975 9.6875 5.1975 9.3275 5.415 9.11C5.6325 8.8925 5.9925 8.8925 6.21 9.11L7.935 10.835L11.79 6.98C12.0075 6.7625 12.3675 6.7625 12.585 6.98C12.8025 7.1975 12.8025 7.55 12.585 7.775Z",
    fill: "#50CD89"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSyncActive);
export default __webpack_public_path__ + "static/media/icon-sync-active.e85718fc7e4793089cebabbbb23d5614.svg";
export { ForwardRef as ReactComponent };